import { profile } from '../data/profile';
import SectionTitle from '../components/ui/SectionTitle';

export default function About() {
  return (
    <section>
      <div className="container">
        <SectionTitle title="关于我" />
        <p className="page-intro">
          {profile.bio} 现居 {profile.location}，在 {profile.company} 从事前端开发。
          自 {profile.since} 年起活跃于 GitHub，持续输出与开源。
        </p>
        <dl className="about-block">
          <dt>name :: </dt>
          <dd>{profile.name}</dd>
          <dt>handle :: </dt>
          <dd>{profile.login}</dd>
          <dt>company :: </dt>
          <dd>{profile.company}</dd>
          <dt>location :: </dt>
          <dd>{profile.location}</dd>
          <dt>github :: </dt>
          <dd>
            <a href={profile.github} target="_blank" rel="noopener noreferrer">
              {profile.github}
            </a>
          </dd>
          <dt>bio :: </dt>
          <dd>{profile.intro}</dd>
          <dt>motto :: </dt>
          <dd>{profile.tagline}</dd>
        </dl>
        <div className="hero-actions" style={{ marginTop: '2rem' }}>
          <a href={profile.github} className="btn btn-primary" target="_blank" rel="noopener noreferrer">
            → GitHub Profile
          </a>
          <a href={profile.resume} className="btn btn-ghost" target="_blank" rel="noopener noreferrer">
            在线简历
          </a>
        </div>
      </div>
    </section>
  );
}
